<template>
  <el-dialog
    class="video-player"
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    :destroy-on-close="true"
    :close-on-click-modal="false"
    :append-to-body="true"
    @close="closeHandle"
    style="z-index: 10000"
    v-if="dialogVisible"
  >
    <video
      id="myVideo"
      :src="video_src"
      width="100%"
      controls
      autoplay
      :poster="require('@/assets/images/common/video-poster-default.png')"
      webkit-playsinline="true"
      playsinline="true"
      controlsList="nodownload"
      x5-playsinline=""
      x-webkit-airplay="allow"
      x5-video-player-type="h5"
      v-if="dialogVisible"
    ></video>
    <div class="close-btn" @click="closeHandle">
      <span class="el-icon-circle-close"></span>
    </div>
  </el-dialog>
</template>

<script>
/*
视频播放器
*/
export default {
  name: "videoPlayer",
  props: {
    dialogTitle: {
      type: String,
      default: "播放视频"
    },
    visible: {
      type: Boolean,
      default: false
    },
    video_src: {
      type: String,
      default: ""
    },
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
    }
  },
  data() {
    return {
      dialogVisible: false
    }
  },
  methods: {
    closeHandle() {
      let myVideo = document.getElementById('myVideo')
      myVideo.style.left = "-1000%"
      myVideo.pause()
      myVideo.removeAttribute('src')
      myVideo.load()
      myVideo.style.display = 'none'
      myVideo = null
      this.$nextTick(() => {
        setTimeout(() => {
          this.dialogVisible = false
          this.$emit('dialogClose')
        }, 100)
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.video-player{
  text-indent: 0;

  video{
    width: 100%;
    height: 422rem;
  }

  .close-btn{
    font-size: 40rem;
    color: #e3e3e3;
    position: absolute;
    bottom: -90rem;
    left: 50%;
    margin-left: -23rem;
    cursor: pointer;
  }
}
/deep/.el-dialog{
  width: 750rem;
  height: 422rem;
  background: rgba(0, 0, 0, 0.65);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0 !important;
  bottom: auto;
  min-height: auto;

  .el-dialog__header{
    display: none;
  }
  .el-dialog__body{
    padding: 0;
  }
}
</style>